module.exports = __webpack_public_path__ + "img/AdobeStock_92505360.e960f580.jpg";